import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/images/escudo.png";
import nafLogo from "../../assets/images/naf.jpg";
import { FiMenu, FiX } from "react-icons/fi";
import React, { useState } from "react";
import "../../assets/styles/Header.css";

function Header() {
  const { user, rol, userData, handleLogout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => {
    setMenuOpen(false);

    setTimeout(() => {
      if (window.innerWidth <= 768) {
        const header = document.getElementById("site-header");
        const headerHeight = header?.offsetHeight || 0;
        window.scrollTo({
          top: headerHeight,
          behavior: "smooth",
        });
      }
    }, 100);
  };

  const handleSignOut = async () => {
    await handleLogout();
    window.location.href = "/";
  };

  const commonLinks = (basePath) => (
    <>
      <Link to={`${basePath}/inicio`}>Inicio</Link>
      <Link to={`${basePath}/quienes`}>¿Quiénes Somos?</Link>
      <Link to={`${basePath}/servicios`}>Solicitar Asesoría</Link>
      <Link to={`${basePath}/biblioteca`}>Biblioteca</Link>
      <Link to={`${basePath}/boletines`}>Boletines Contables</Link>
      <Link to={`${basePath}/naf`}>NAF</Link>
      <Link to={`${basePath}/galeria`}>Galería</Link>
      <Link to={`${basePath}/inscripcion`}>Formulario de Inscripción</Link>
    </>
  );

  const roleSpecificLinks = {
    1: (
      <div className="w-full text-center mt-6">
        <p className="text-sm font-bold text-gray-600 mb-2 uppercase">
          Opciones para Admin
        </p>
        <div className="flex flex-wrap justify-center gap-2">
          <Link to="/dashboard-admin/ver-asesorias" className="btn-header">
            Ver Asesorías Solicitadas
          </Link>
          <Link to="/dashboard-admin/usuarios" className="btn-header">
            Usuarios
          </Link>
          <Link to="/dashboard-admin/boletines-manager" className="btn-header">
            Gestionar Boletines
          </Link>
          <Link to="/dashboard-admin/libros-manager" className="btn-header">
            Gestionar Biblioteca
          </Link>
          <Link to="/dashboard-admin/ver-inscripciones" className="btn-header">
            Inscripciones Registradas
          </Link>
        </div>
      </div>
    ),
    2: (
      <div className="w-full text-center mt-6">
        <p className="text-sm font-bold text-gray-600 mb-2 uppercase">
          Opciones para Editor
        </p>
        <div className="flex flex-wrap justify-center gap-2">
          <Link to="/dashboard-editor/ver-asesorias" className="btn-header">
            Ver Asesorías Solicitadas
          </Link>
          <Link to="/dashboard-editor/usuarios" className="btn-header">
            Usuarios
          </Link>
          <Link to="/dashboard-editor/boletines-manager" className="btn-header">
            Gestionar Boletines
          </Link>
          <Link to="/dashboard-editor/libros-manager" className="btn-header">
            Gestionar Biblioteca
          </Link>
          <Link to="/dashboard-editor/ver-inscripciones" className="btn-header">
            Inscripciones Registradas
          </Link>
        </div>
      </div>
    ),
  };

  const perfilPath =
    rol === 1
      ? "/dashboard-admin/perfil"
      : rol === 2
        ? "/dashboard-editor/perfil"
        : "/dashboard-usuario/perfil";

  return (
    <header id="site-header" className="header bg-white shadow-md">
      <div className="header-top flex items-center justify-between p-4 w-full">
        {/* Logo de la Universidad (Escudo) a la izquierda */}
        <div className="flex flex-col items-start">
          <img src={logo} alt="Escudo" className="logo mb-2" />
        </div>

        {/* Título centrado y logo de NAF a la derecha */}
        <div className="flex flex-col items-center justify-center flex-1">
          <h1 className="title text-lg font-bold text-green-900">NÚCLEO DE APOYO CONTABLE Y FISCAL - ESPE</h1>
        </div>

        <div className="flex flex-col items-center justify-center md:items-end ml-4">
          <img src={nafLogo} alt="NAF Logo" className="logo mb-2" />
          {!user ? (
            <div className="flex gap-2 mt-1">
              <Link to="/login" className="btn-login">Iniciar Sesión</Link>
              <Link to="/register" className="btn-register">Registrarse</Link>
            </div>
          ) : (
            <div className="text-center mt-2">
              <p className="session-name">
                {rol === 3
                  ? userData?.Username || "Usuario"
                  : `${userData?.Username || "Nombre"} (${rol === 1 ? "Admin" : "Editor"})`}
              </p>
              <div className="flex gap-2 justify-center mt-1">
                <Link to={perfilPath} className="btn-perfil">Perfil</Link>
                <button onClick={handleSignOut} className="btn-logout">Cerrar Sesión</button>
              </div>
            </div>
          )}
        </div>

        {/* Botón menú móvil */}
        <div className="md:hidden">
          <button onClick={toggleMenu}>
            {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Menú de navegación */}
      <nav className={`flex flex-col md:flex-row md:flex-wrap gap-3 md:gap-6 items-center justify-center transition-all duration-300 ${menuOpen ? "block" : "hidden"} md:block px-4 pb-4`}>
        {!isDashboard && (
          <>
            <Link to="/" onClick={closeMenu}>Inicio</Link>
            <Link to="/quienes" onClick={closeMenu}>¿Quiénes Somos?</Link>
            <Link to="/servicios" onClick={closeMenu}>Solicitar Asesoría</Link>
            <Link to="/biblioteca" onClick={closeMenu}>Biblioteca</Link>
            <Link to="/boletines" onClick={closeMenu}>Boletines Contables</Link>
            <Link to="/naf" onClick={closeMenu}>NAF</Link>
            <Link to="/galeria" onClick={closeMenu}>Galería</Link>
            <Link to="/inscripcion" onClick={closeMenu}>Formulario de Inscripción</Link>
          </>
        )}

        {isDashboard && user && (
          <>
            {rol === 1 && (
              <>
                {commonLinks("/dashboard-admin")}
                {roleSpecificLinks[1]}
              </>
            )}
            {rol === 2 && (
              <>
                {commonLinks("/dashboard-editor")}
                {roleSpecificLinks[2]}
              </>
            )}
            {rol === 3 && <>{commonLinks("/dashboard-usuario")}</>}
          </>
        )}
      </nav>
    </header>
  );
}

export default Header;
